import Vue from "vue";
import Router from "vue-router";
import guardianRouter from "@/routes/guardian";

Vue.use(Router);
const baseRoute = [
    {
        path: "",
        component: () => import("./layout/blank/Blank.vue"),
        children: [
            {
                path: "/",
                redirect: "view/login",
            },
            {
                path: "view/login",
                name: "Login",
                index: 1,
                component: () => import("./views/authentication/Login.vue"),
            },
            {
                // Ruta para el callback de OAuth de Microsoft
                path: "/view/login/oauth2/code/azure",
                name: "OAuthCallback",
                index: 5, // Asigna un índice siguiente disponible
                component: () => import("./views/authentication/Login.vue"), // Reutilizamos el mismo componente
                meta: { 
                    isOAuthCallback: true // Meta información útil para identificar que es un callback
                }
            },
            {
                path: "/error404",
                name: "Error 404",
                index: 2,
                component: () => import("./views/authentication/Error404.vue"),
            },
            {
                path: "view/pay/payu/confirmation",
                name: "PayU",
                index: 3,
                component: () => import("./views/pay/confirmation/PayU.vue"),
            },
            {
                path: "view/public/users",
                name: "Registro usuarios",
                index: 4,
                component: () => import("./views/public/users/index.vue"),
            },
            {
                path: "view/new/password",
                name: "NewPassword",
                index: 1,
                component: () => import("./views/authentication/NewPassword.vue"),
            },
        ],
    },
    {
        path: "",
        meta: {
            requiresAuth: true,
        },
        component: () => import("./layout/full/MainContainer.vue"),
        children: [
            {
                path: "view/start",
                name: " ",
                index: 3,
                i18n: "Starterkit",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/StarterPage.vue"),
            },
            {
                path: "view/company/create",
                name: "Crear Empresa",
                index: 4,
                i18n: "CreateCompany",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/company/create/CreateCompany.vue"),
            },
            {
                path: "view/company/settings/operating-parameters",
                name: "Parámetros de funcionamiento",
                index: 4,
                i18n: "operating-parameters",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/company/settings/operating-parameters/operating-parameters.vue"),
            },
            {
                path: "view/slot/create",
                name: "Gestion Lotes",
                index: 5,
                i18n: "CreateSlot",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/slots/index.vue"),
            },
            {
                path: "view/devices/configuration",
                name: "Configuración Dispositivos",
                index: 6,
                i18n: "ConfigDevice",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/devices/configuration/ConfigDevices.vue"),
            },
            {
                path: "view/devices/add",
                name: "Agregar Dispositivo",
                index: 7,
                i18n: "AddDevice",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/devices/configuration/AddDevice.vue"),
            },
            {
                path: "view/devices/license",
                name: "Agregar Licencia",
                index: 7,
                i18n: "GenerateLicense",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/devices/configuration/GenerateLicense.vue"),
            },
            {
                path: "view/pays/methods/gestion",
                name: "Gestión métodos de pago",
                index: 9,
                i18n: "PayMethods",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/pay/methods/PaymentMethod.vue"),
            },
            {
                path: "view/devices/terminals",
                name: "Gestión Terminales",
                index: 8,
                i18n: "GestionTerminals",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/devices/terminals/TerminalsList.vue"),
            },
            {
                path: "view/devices/permissions",
                name: "Gestión Permisos",
                index: 8,
                i18n: "GestionPermises",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/devices/permises/ConfigPermisses.vue"),
            },
            {
                path: "view/calendar",
                name: "Calendario",
                index: 9,
                i18n: "CreateCompany",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/calendar/index.vue"),
            },
            {
                path: "view/discounts",
                name: "Descuentos",
                index: 10,
                i18n: "Discount",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/discount/discount-management.vue"),
            },
            {
                path: "view/rate",
                name: "Registro Tarifas",
                index: 11,
                i18n: "rates",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/rate/index.vue"),
            },
            {
                path: "view/rate/list",
                name: "Consultar Tarifas",
                index: 11,
                i18n: "ratesQuery",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/rate/List/index.vue"),
            },
            {
                path: "view/rate/manage",
                name: "Gestionar Tarifas",
                index: 11,
                i18n: "manageRate",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/rate/current-rates/current-rates.vue"),
            },
            {
                path: "/view/users/entities/create",
                name: "Crear tercero",
                index: 11,
                i18n: "entityRegister",
                props: true,
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/users/entities/create/index.vue"),
            },
            {
                path: "/view/users/entities/edit",
                name: "Editar tercero",
                index: 11,
                i18n: "entityRegister",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/users/entities/create/index.vue"),
            },

            {
                path: "/view/users/management/:accessCode?",
                name: "Administrar accesos",
                index: 11,
                i18n: "access",
                props: true,
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/users/user/User"),
            },
            {
                path: "view/resolution/:resolutionId?",
                name: "Resolución",
                index: 12,
                i18n: "Resolution",
                meta: {
                    requiresAuth: true,
                },
                props: true,
                component: () =>
                    import ("@/views/resolution/index.vue"),
            },
            {
                path: "view/resolutions/list",
                name: "Listar Resolución",
                index: 12,
                i18n: "Resolution",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import ("@/views/resolution/list/ResolutionList"),
            },
            {
                path: "view/schedules",
                name: "Configuración horarios",
                index: 13,
                i18n: "schedules",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/schedules/index.vue"),
            },
            {
                path: "view/income-setting",
                name: "Configuración de ingresos",
                index: 14,
                i18n: "monthly",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/income-special/income-setting/index.vue"),
            },
            {
                path: "view/subscriber/:subscriberId?",
                name: "CREAR ABONADO",
                index: 15,
                i18n: "monthly",
                props: true,
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/income-special/subscriber/Subscriber"),
            },
            {
                path: "view/subscribers/list",
                name: "LISTAR ABONADOS",
                index: 16,
                i18n: "monthly",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/income-special/list-subscriber/index"),
            },
            {
                path: "view/store",
                name: "Registro de Tiendas",
                index: 17,
                i18n: "store",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/store/index.vue"),
            },
            {
                path: "view/concepts",
                name: "Interfaz de Conceptos",
                index: 18,
                i18n: "concepts",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/concepts/index.vue"),
            },
            {
                path: "view/liquidation",
                name: "Interfaz de Liquidación",
                index: 19,
                i18n: "liquidation",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/liquidation/index.vue"),
            },
            {
                path: "view/liquidation/list",
                name: "Consultar Liquidación",
                index: 19,
                i18n: "liquidation",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/liquidation/List/index.vue"),
            },
            {
                path: "view/liquidation/manage",
                name: "Gestionar Liquidaciones",
                index: 19,
                i18n: "liquidation",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/liquidation/current-liquidations/current-liquidations.vue"),
            },
            {
                path: "view/pos",
                name: "Interfaz de Caja",
                index: 20,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/pos/index.vue"),
            },
            {
                path: "view/configuration/sync",
                name: "Configuración sincronizador",
                index: 20,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/configuration/sync/index.vue"),
            },
            {
                path: "view/configuration/accounting-integrations",
                name: "Configuración integraciones contables",
                index: 20,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/configuration/accounting-integration/accounting-integration.vue"),
            },
            {
                path: "view/pays/methods/configuration",
                name: "Configuración métodos de pago",
                index: 20,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/pay/methods"),
            },
            {
                path: "view/Aerooriente/reports/FiscalReport",
                name: "Reporte Fiscal Aerooriente",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/aerooriente/fiscal-report/fiscal-report.vue"),
            },
            {
                path: "view/easypunto/reports/electronic-billing",
                name: "Facturación Electrónica",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/easypunto/reports/ElectronicBilling"),
            },
            {
                path: "view/overview-report/reports/collection-report",
                name: "Consolidado de Recaudos Diarios",
                index: 22,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/overview-report/reports/collection-report/collection-report"),
            },
            {
                path: "/view/overview-report/reports/detail-invoice",
                name: "Movimiento detallado de facturación",
                index: 23,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/overview-report/reports/parking/detail-invoice/detail-invoice.vue"),
            },
            {
                path: "/view/overview-report/reports/monthly-active",
                name: 'monthlyActiveReport.title',
                index: 27,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/overview-report/reports/monthly-active/monthly-active"),
            },
            {
                path: "view/overview-report/reports/centro-mayor-frequency",
                name: "Reporte Frecuencia De Ingreso",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/centro-mayor/frequency/frequency"),
            },
            {
                path: "view/overview-report/reports/centro-mayor-finance-collection",
                name: "Consolidado De Informe Financiero",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/centro-mayor/finance-collection/finance-collection"),
            },
            {
                path: "view/overview-report/reports/centro-mayor-invoice",
                name: "Detallado De Facturación",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/centro-mayor/invoice-mall/invoice-mall"),
            },
            {
                path: "/view/overview-report/reports/concept-invoice",
                name: "Facturación por conceptos",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/parking/concept-invoice/concept-invoice.vue"),
            },
            {
                path: "/view/overview-report/reports/electronic-invoice/detail/:documentId?",
                name: "Ver Detalle",
                props: true,
                meta: {
                    title: "Facturación por conceptos",
                    breadcrumb: [
                        {
                            title: 'Facturación por conceptos',
                            active: false,
                            //url: "/view/overview-report/reports/concept-invoice"
                        },
                        {
                            title: 'Resumen documento electrónico',
                            active: true
                        }
                    ]
                },
                component: () => import("./views/overview-report/reports/parking/electronic-detail/electronic-detail.vue")
            },
            {
                path: "view/overview-report/reports/centro-mayor-collection",
                name: "Consolidado Diario De Facturación",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/centro-mayor/collection-mall/collection-mall"),
            },
            {
                path: "view/overview-report/reports/centro-mayor-monthly-active",
                name: "Reporte mensuales Activos",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/centro-mayor/monthly-active-mall/monthly-active-mall.vue"),
            },
            {
                path: "view/users/entities/list",
                name: "Consulta terceros",
                index: 23,
                i18n: "ConfigDevice",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/users/entities/List"),
            },
            {
                path: "view/users/list",
                name: "Consulta accesos",
                index: 22,
                i18n: "QueryAccess",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/users/user/List"),
            },
            {
                path: "/view/overview-report/reports/purge-record",
                name: "Registros Purgados",
                index: 26,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/overview-report/reports/purge-report/purge-report"),
            },
            {
                path: "view/overview-report/reports/centro-mayor-purge-record",
                name: "Reporte registros Purgados",
                index: 26,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/overview-report/reports/centro-mayor/purge-report-mall/purge-report-mall.vue"),
            },
            {
                path: "view/overview-report/reports/closures-report",
                name: "Cierres de caja",
                index: 27,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/overview-report/reports/closures-report/closures-report.vue"),
            },
            {
                path: "/view/overview-report/reports/occupation",
                name: "Reporte Ocupación",
                index: 23,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/occupation"),
            },
            {
                path: "/view/overview-report/reports/frequency",
                name: "Reporte Frecuencia",
                index: 23,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/parking/parking-frequency/parking-frequency.vue"),
            },
            {
                path: "/view/overview-report/reports/permanence",
                name: "Reporte Permanencia",
                index: 23,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/parking/parking-permanence/parking-permanence.vue"),
            },
            {
                path: "view/configuration/checktoken",
                name: "Verificar token",
                index: 27,
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/configuration/Checktoken"),
            },
            {
                path: "view/company/search",
                name: "Consulta empresas",
                index: 23,
                i18n: "companySearch",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/company/List"),
            },
            {
                path: "/view/overview-report/reports/products",
                name: "Reporte de productos",
                index: 23,
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/product-report/product-report.vue"),
            },
            {
                path: "/view/overview-report/reports/lockers/concept-invoice",
                name: "Detallado de facturación por conceptos",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/locker/locker-invoice/locker-invoice.vue"),
            },
            {
                path: "view/overview-report/reports/lockers/collection-invoice",
                name: "Consolidado de facturación por estación",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/locker/locker-collection/locker-collection.vue"),
            },
            {
                path: "view/slots/purge",
                name: "Purgar movimientos",
                index: 30,
                i18n: "purge",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/my-services/purge-movement/purge-movement.vue"),
            },
            {
                path: "view/invoice/cancel",
                name: "Anulación de facturas",
                index: 30,
                i18n: "purge",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/my-services/invoice-cancellation/invoice-cancellation.vue"),
            },
            {
                path: "view/overview-report/reports/lockers/frequency-data",
                name: "Frecuencia casilleros",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/locker/locker-frequency/locker-frequency.vue"),

            },
            {
                path: "view/overview-report/reports/novaSoft-sht",
                name: "Reporte novasoft sociedad hotelera tequendama",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/integrations/novaSoft/novasoft-sht/novasoft-sht.vue"),

            },
            {
                path: "view/overview-report/reports/worldOffice-hic",
                name: " Reporte worldOffice hospital internacional de colombia",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/integrations/worldOffice/worldoOffice-hic/worldoffice-hic.vue"),

            },
            {
                path: "view/overview-report/reports/worldOffice-yopal",
                name: "Reporte worldOffice unicentro yopal",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/integrations/worldOffice/worldOffice-yopal/worldOffice-yopal.vue"),

            },
            {
                path: "view/overview-report/reports/integrations/fiduciaryAlliance",
                name: "Reporte alianza fiduciaria",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/integrations/pactia/fiduciary-alliance/fiduciary-alliance.vue"),

            },
            {
                path: "view/overview-report/reports/integrations/fiduciaryBancolombia",
                name: "Reporte fiduciaria bancolombia",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/integrations/pactia/fiduciary-bancolombia/fiduciary-bancolombia.vue"),

            },
            {
                path: "view/overview-report/reports/integrations/sht/production",
                name: "Reporte de producción sociedad hotelera tequendama",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/integrations/sht/production/production.vue"),

            },
            {
                path: "view/overview-report/reports/integrations/helisa/transactions",
                name: "Movimiento contable helisa",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/integrations/helisa/alferez/accounting-transactions.vue"),

            },
            {
                path: "view/overview-report/reports/integrations/contai/template",
                name: "Plantillas contai",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/integrations/contai/vegas/contai-report.vue"),

            },
            {
                path: "view/overview-report/reports/cancellation-invoice",
                name: "Facturas anuladas",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/parking/cancellation-invoice/cancellation-invoice.vue"),

            },
            {
                path: "view/overview-report/reports/invoice-bathrooms",
                name: "Detallado de recaudo baños",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/bathrooms/invoice-bathrooms/invoice-bathrooms.vue"),

            },
            {
                path: "view/overview-report/reports/collection-bathrooms",
                name: "Consolidado de recaudo baños",
                i18n: "pos",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/overview-report/reports/bathrooms/collection-bathrooms/collection-bathrooms.vue"),

            },
            {
                path: "view/external/setting",
                name: "Configuración datos externo",
                i18n: "ExternalSetting",
                meta: {
                    requiresAuth: true,
                },
                component: () => import("./views/external/external-setting.vue"),
            },
        ],
    },
    // Redirect to 404 page, if no match found
    {
        path: "*",
        redirect: "/Error404",
    },
];

const routes = baseRoute.concat(guardianRouter);
const router = new Router({
    mode: "history",
    scrollBehavior() {
        return {
            x: 0,
            y: 0,
        };
    },
    base: process.env.BASE_URL,
    routes,
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start();
    }
    next();
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (localStorage.getItem("x-token") == null) {
            next({
                path: "view/login",
                index: 0,
            });
        } else {
            next();
        }
    }
    next();
});

router.afterEach(() => {
    // Complete the animation of the route progress bar.
    NProgress.done();
});

export default router;
